import { useContext, useState } from "react";
import IProcessSalesRepDTO from "../../../models/DTO/IProcessSalesRepDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOwTableCols from "../../../models/IOwTableCols";
import IRepGroup from "../../../models/IRepGroup";
import ISalesRep from "../../../models/ISalesRep";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTable from "../../shared/OwTable/OwTable";
import SalesRepSidebar from "../SalesRepSidebar/SalesRepSidebar";
import { ConfirmDeleteOverlayFn } from "../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import { OwDeleteEditActions } from "../../shared/OwDeleteEditActions/OwDeleteEditActions";
import { useAppContextNonNull } from "@contexts/AppContext";

type Props = {
    salesReps: ISalesRep[];
    repGroup: IRepGroup;
    parentRowIndex: number;
    cancelSidebar: (refreshData?: boolean) => void;
};

export const RepGroupRepsDetail = (props: Props) => {
    const { socket, userModel, supplierModel, uiContext } = useAppContextNonNull();

    const renderActions = (row: ISalesRep, index: number, isDetailViewTable?: boolean, parentRowIndex?: number) => {
        return (
            <div>
                <OwDeleteEditActions
                    isEditMode={false}
                    onTrashClickFn={() => {
                        toggleDelete(row, index, isDetailViewTable, parentRowIndex);
                    }}
                    onEditClickFn={() => {}}
                    hideEdit={true}
                />
            </div>
        );
    };

    const getColumns = (): IOwTableCols[] => {
        return [
            {
                title: "",
                valueProp: "",
                renderFn: renderActions,
                renderFnEmitsRow: true,
                isActionsCol: true,
            },
            {
                title: "name",
                valueProp: "User",
                valueSubProp: "name",
            },
            {
                title: "email",
                valueProp: "User",
                valueSubProp: "email",
            },
        ];
    };

    const [sourceElement, setSourceElement] = useState<any>(null);
    const [sourceElementId, setSourceElementId] = useState<string>("");
    const [sourceSalesRep, setSourceSalesRep] = useState<ISalesRep | null>(null);
    const columns = getColumns();

    const toggleDelete = (row: ISalesRep, index: number, isDetailViewTable?: boolean, parentRowIndex?: number) => {
        const element = document.getElementById(`row-${parentRowIndex}-${index}`);

        setSourceElement(element);
        setSourceElementId(`row-${parentRowIndex}-${index}`);
        setSourceSalesRep(row);
    };

    const editRow = (row: ISalesRep, index: number) => {
        create();
    };

    const create = () => {
        // let salesRepModel = salesRep || ({ rep_group_id: this.props.repGroup.id, name: "", email: "" } as ISalesRep);

        const component = (
            <SalesRepSidebar
                setActivityIndicator={uiContext.setActivityIndicator}
                socket={socket}
                supplierModel={supplierModel}
                userModel={userModel}
                cancelFn={props.cancelSidebar}
                notifyFn={uiContext.notifyFn}
                repGroup={props.repGroup}
            />
        );

        uiContext.setSidebarComponent(component);
        uiContext.toggleSidebar(true);
    };

    const cancelDelete = () => {
        setSourceElement(null);
        setSourceElementId("");
    };

    const commitDelete = () => {
        if (sourceSalesRep) {
            const payload: IProcessSalesRepDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                salesRep: sourceSalesRep,
                deleteFlag: true,
            };

            socket.emit(EndpointsEnum.RepGroupProcessSalesRep, payload);

            setSourceElement(null);
        }
    };

    return (
        <div className={"RepGroupRepsDetail"}>
            <div className={"mb-2"}>
                <OwLabel title={"users"} noBottomMargin={true} className={"me-2"} />
                <OwButton
                    title={"add"}
                    fn={() => {
                        create();
                    }}
                    leftIconClass={"fas fa-plus"}
                />
            </div>

            <div className={"table-responsive position-relative"}>
                <ConfirmDeleteOverlayFn
                    targetElem={sourceElementId}
                    handleConfirm={commitDelete}
                    handleCancel={cancelDelete}
                    nestedParentElem={`rep-group-detail-${props.parentRowIndex}`}
                    skipMainView={true}
                />

                <OwTable
                    id={`rep-group-detail-${props.parentRowIndex}`}
                    isDetailViewTable={true}
                    parentRowIndex={props.parentRowIndex}
                    columns={columns}
                    dataSet={props.salesReps}
                    userModel={userModel}
                    supplierModel={supplierModel}
                    dataFetch={false}
                    initialData={false}
                />
            </div>
        </div>
    );
};
